import { render, staticRenderFns } from "./WebNewsUpdate.vue?vue&type=template&id=8140b67e&"
import script from "./WebNewsUpdate.vue?vue&type=script&lang=js&"
export * from "./WebNewsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WebNewsUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports